import cx from 'classnames';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime.js';

import type { Author } from '~/interfaces/author';

import Typography from '../Typography';

dayjs.extend(relativeTime);

interface Props {
  time: string;
  authors: Author[];
  fontFamily: string;
  textClassName?: string;
  color?: string;
}

function formatPostTime(postTime: dayjs.Dayjs) {
  const now = dayjs();
  let diffHours = now.diff(postTime, 'hour');

  if (diffHours === 0) {
    diffHours = 1;
  }

  if (diffHours === 1) {
    return `${diffHours} hour ago`;
  }

  if (diffHours < 24) {
    return `${diffHours} hours ago`;
  }

  return postTime.locale('en').format('MMM DD, YYYY');
}

const Details = ({ time, authors, fontFamily, textClassName, color }: Props) => {
  const postTime = dayjs(time);
  const formattedTime = formatPostTime(postTime);

  return (
    <Typography
      size="sm"
      fontFamily={fontFamily}
      className={cx('flex flex-col space-y-1 no-underline opacity-75', textClassName)}
      color={color}
      weight="regular"
    >
      <span className="text-xs font-semibold">{authors?.map((author: Author) => author.name).join(', ')}</span>
      <time dateTime={time} className="text-xs">
        {formattedTime}
      </time>
    </Typography>
  );
};

export default Details;
